import React from "react";

import { Navbar } from "../../../components";
import Lloyds from "./Lloyds";

const LloydsProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Lloyds />
    </div>
  );
};

export default LloydsProject;
